import * as UnifyIcons from 'src/components/UnifyIcons';

/**
 * The Unify `workiva_document` icon.
 *
 * Example usage:
 * ```dart
 * (IconButton()..aria.label = 'Workiva Document')(
 *   WorkivaDocumentIcon()(),
 * )
 * ```
 *
 * If necessary, this icon can be retrieved in tests using the test ID `unify.icons.workivaDocument`.
 *
 * Tags: workiva, document, file, draft
 *
 * @deprecated Use `UnifyIcons.WorkivaDocument` instead.
 */
export const WorkivaDocumentIcon = UnifyIcons.WorkivaDocument;

/**
 * The Unify `workiva_spreadsheet` icon.
 *
 * Example usage:
 * ```dart
 * (IconButton()..aria.label = 'Workiva Spreadsheet')(
 *   WorkivaSpreadsheetIcon()(),
 * )
 * ```
 *
 * If necessary, this icon can be retrieved in tests using the test ID `unify.icons.workivaSpreadsheet`.
 *
 * Tags: workiva, spreadsheet, table, grid, data
 *
 * @deprecated Use `UnifyIcons.WorkivaSpreadsheet` instead.
 */
export const WorkivaSpreadsheetIcon = UnifyIcons.WorkivaSpreadsheet;

/**
 * The Unify `workiva_presentation` icon.
 *
 * Example usage:
 * ```dart
 * (IconButton()..aria.label = 'Workiva Presentation')(
 *   WorkivaPresentationIcon()(),
 * )
 * ```
 *
 * If necessary, this icon can be retrieved in tests using the test ID `unify.icons.workivaPresentation`.
 *
 * Tags: workiva, presentation, deck, slideshow, keynote
 *
 * @deprecated Use `UnifyIcons.WorkivaPresentation` instead.
 */
export const WorkivaPresentationIcon = UnifyIcons.WorkivaPresentation;

/**
 * The Unify `workiva_flowchart` icon.
 *
 * Example usage:
 * ```dart
 * (IconButton()..aria.label = 'Workiva Flowchart')(
 *   WorkivaFlowchartIcon()(),
 * )
 * ```
 *
 * If necessary, this icon can be retrieved in tests using the test ID `unify.icons.workivaFlowchart`.
 *
 * Tags: workiva, flowchart, diagram, workflow, blueprint, schematic, infographic, roadmap, framework, chart, model, visualization, plan, structure, mapping, pathway
 *
 * @deprecated Use `UnifyIcons.WorkivaFlowchart` instead.
 */
export const WorkivaFlowchartIcon = UnifyIcons.WorkivaFlowchart;
